import React from 'react';
import Proptypes from 'prop-types';
import { Grid, Row, Col, Table, Glyphicon } from 'react-bootstrap';
import { getRoundedNumber } from './DataCollection/DataCollectionHelper';

/**
 * React component which renders a table depicting the selected frames and associated cumputed values such as I0, Rg, Mass and a link to download the data.
 */
class SaxsHPLCSummaryTable extends React.Component {
    render() {
        if (this.props.frames && this.props.frames.length > 0) {
            return <Grid fluid>
                <Row>
                    <Col xs={12} md={12} >
                        <Table>
                            <thead>
                                <tr>
                                    <th>Frame</th>
                                    <th>I0</th>
                                    <th>Rg</th>
                                    <th>Mass</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.frames.map(frame => {
                                    return <tr>
                                        <td>{frame.frameId}</td>
                                        <td> {getRoundedNumber(frame.I0, 1, false)} </td >
                                        <td> {getRoundedNumber(frame.rg, 1, false)} </td >
                                        <td> {getRoundedNumber(frame.mass, 1, false)} </td >
                                        <td> <a href={frame.downloadUrl} style={{ cursor: 'pointer' }}> <Glyphicon glyph='download' style={{ fontSize: '14px' }} /> </a> </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        } else {
            return null;
        };
    }
}

export default SaxsHPLCSummaryTable;

SaxsHPLCSummaryTable.proptypes = {
    /** selected frames */
    frames: Proptypes.object
}


// WEBPACK FOOTER //
// ./src/components/saxs/SaxsHPLCSummaryTable.js